
<script>
import NewForm from "./New";
export default {
  mixins: [NewForm],
  mounted() {
    this.load();
  },
  computed: {
    isEdit() {
      return true;
    },
  },
  methods: {
    load() {
      this.$http.get(`/container-types/${this.$route.query.id}`).then((res) => {
        this.form = { ...res.data, name: res.data.locales.ja_JP };
      });
    },
    save() {
      this.$http
        .put(`/container-types/${this.$route.query.id}`, this.form)
        .then(() => {
          this.$router.go(-1);
        });
    },
    remove() {
      this.$http.delete(`/container-types/${this.$route.query.id}`).then(() => {
        this.$router.go(-1);
      });
    },
  },
};
</script>
